module.exports = __webpack_public_path__ + "img/wand.e8a153e2.svg";